
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 365","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M505.8 242.6c0-31.5-23.1-57.7-53.5-63-5.2-33.6-37.8-58.8-73.4-52.5-31.5 5.2-53.5 33.6-53.5 66.1v68.2c0 38.8-28.3 74.5-67.2 79.7-47.2 6.3-87.1-30.4-87.1-76.6v-61.9h47.2c3.1 0 5.2-2.1 5.2-5.2v-47.2h36.7c3.1 0 5.2-2.1 5.2-5.2v-31.5H279c17.8 0 34.6-12.6 38.8-30.4C323.2 59 304.3 37 281.2 37h-14.7V5.5c-2.1-3.1-4.2-5.2-7.3-5.2H57.7c-3.1 0-5.2 2.1-5.2 5.2V37H38.8C21 37 4.2 49.6 1.1 67.4c-5.2 24.1 13.6 46.2 36.7 46.2h14.7V145c0 3.1 2.1 5.2 5.2 5.2h36.7v47.2c0 3.1 2.1 5.2 5.2 5.2h47.2v57.7c0 53.5 40.9 100.7 94.4 103.9 58.8 4.2 108.1-43 108.1-100.7v-71.3c0-19.9 14.7-38.8 34.6-42 21-3.1 39.9 10.5 45.1 29.4-29.4 6.3-51.4 31.5-51.4 63v58.8c0 3.1 2.1 5.2 5.2 5.2H409v35.7c0 3.1 2.1 5.2 5.2 5.2h12.6c3.1 0 5.2-2.1 5.2-5.2v-35.7h18.9v35.7c0 3.1 2.1 5.2 5.2 5.2H469c3.1 0 5.2-2.1 5.2-5.2v-35.7h26.2c3.1 0 5.2-2.1 5.2-5.2zM264.4 61.1h14.7c8.4 0 14.7 6.3 14.7 14.7s-6.3 14.7-14.7 14.7h-14.7zM52.5 89.4H37.8c-8.4 0-14.7-6.3-14.7-14.7S29.4 60 37.8 60h14.7zm41.9 36.8H75.6V23.3h165.8v102.8h-147zm24.2 52.4v-29.4h80.8v29.4zm364.1 104.9h-81.8v-40.9c0-22 17.8-40.9 40.9-40.9s40.9 18.9 40.9 40.9z"}})])
          )
        }
      }
    